export function TopbarIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4 3.2H7.6C5.54978 3.2 3.82707 4.60225 3.33862 6.5L20.6614 6.5C20.1729 4.60225 18.4502 3.2 16.4 3.2ZM3.2 16.4V8.7L20.8 8.7V16.4C20.8 18.8301 18.8301 20.8 16.4 20.8H7.6C5.16995 20.8 3.2 18.8301 3.2 16.4ZM7.6 1C3.95492 1 1 3.95492 1 7.6V16.4C1 20.0451 3.95492 23 7.6 23H16.4C20.0451 23 23 20.0451 23 16.4V7.6C23 3.95492 20.0451 1 16.4 1H7.6ZM9.40293 14.6733C8.95461 14.2786 8.95461 13.5952 9.40293 13.2005L11.3042 11.5266C11.6979 11.1799 12.3022 11.1799 12.6959 11.5266L14.5971 13.2005C15.0454 13.5952 15.0454 14.2786 14.5971 14.6733C14.2034 15.0199 13.5991 15.0199 13.2054 14.6733L12 13.612L10.7946 14.6733C10.4009 15.0199 9.79662 15.0199 9.40293 14.6733Z"
        fill="currentColor"
      />
    </svg>
  );
}
